@if (session(); as s) {
  <div class="page live-scoring">
    <header class="live-head">
      <div class="live-head__title">
        <p class="brijjsports-page-kicker">Coach · Archery</p>
        <h1 class="brijjsports-page-title">{{ s.name ?? 'Scoring session' }}</h1>
        <p class="live-head__meta">
          <span [class]="statusClassFor(s)">{{ statusLabelFor(s) }}</span>
          <span>· {{ archers().length }} archer{{ archers().length === 1 ? '' : 's' }}</span>
          <span>· {{ s.indoor ? 'Indoor' : 'Outdoor' }}</span>
          <span>· {{ s.rounds?.length ?? 0 }} round{{ (s.rounds?.length ?? 0) === 1 ? '' : 's' }}</span>
        </p>
      </div>

      <div class="live-head__actions">
        @if (isLive()) {
          <button mat-stroked-button (click)="pause()">
            <mat-icon>pause</mat-icon>
            Pause
          </button>
          <button mat-flat-button color="primary" (click)="end()">
            <mat-icon>stop</mat-icon>
            End
          </button>
        }
        @if (isPaused()) {
          <button mat-flat-button color="primary" (click)="resume()">
            <mat-icon>play_arrow</mat-icon>
            Resume
          </button>
          <button mat-stroked-button (click)="end()">
            <mat-icon>stop</mat-icon>
            End
          </button>
        }
        @if (isCompleted()) {
          <button mat-stroked-button (click)="archive()">
            <mat-icon>archive</mat-icon>
            Archive
          </button>
        }
      </div>
    </header>

    @if (archers().length) {
      <mat-tab-group class="archer-tabs" [selectedIndex]="activeIndex()" (selectedIndexChange)="selectArcher($event)">
        @for (a of archers(); track a.id) {
          <mat-tab [label]="a.name"></mat-tab>
        }
      </mat-tab-group>

      <section class="totals">
        <div class="totals__cell">
          <span class="totals__label">Total</span>
          <span class="totals__value totals__value--big">{{ grandTotal() }}</span>
          <span class="totals__sub">/ {{ maxPointsPossible() }}</span>
        </div>
        <div class="totals__cell">
          <span class="totals__label">Arrows</span>
          <span class="totals__value">{{ arrowsShotCount() }}</span>
          <span class="totals__sub">/ {{ maxArrowsTotal() }}</span>
        </div>
        <div class="totals__cell">
          <span class="totals__label">X · 10</span>
          <span class="totals__value">{{ xs() }} · {{ tens() }}</span>
        </div>
        @if (target(); as t) {
          <div class="totals__cell totals__cell--target">
            <span class="totals__label">Target</span>
            <span class="totals__value">{{ grandTotal() }} / {{ t }}</span>
            <div class="totals__bar"><span [style.width.%]="targetPct()"></span></div>
          </div>
        }
      </section>

      @if ((s.rounds?.length ?? 0) > 1) {
        <div class="round-pills">
          @for (r of s.rounds ?? []; track $index; let i = $index) {
            <button type="button" class="round-pill" [class.is-active]="activeRound() === i" (click)="selectRound(i)">
              R{{ i + 1 }}
            </button>
          }
        </div>
      }

      @if (currentRoundConfig(); as cfg) {
        <section class="ends-grid">
          @for (i of [].constructor(cfg.endsCount); track $index; let endIdx = $index) {
            <div class="end-row" [class.is-current]="endIdx === currentEndIndex() && isLive()">
              <span class="end-row__num">E{{ endIdx + 1 }}</span>
              <div class="end-row__arrows">
                @for (slot of [].constructor(cfg.arrowsPerEnd); track $index; let arrowIdx = $index) {
                  @let arrow = currentRoundEnds()[endIdx]?.[arrowIdx];
                  @if (arrow !== undefined && arrow !== null) {
                    <button
                      type="button"
                      [class]="
                        arrowClass(arrow) + (isEditingArrow(activeRound(), endIdx, arrowIdx) ? ' arrow--editing' : '')
                      "
                      [disabled]="!isLive()"
                      (click)="beginEdit(activeRound(), endIdx, arrowIdx)"
                    >
                      {{ arrowDisplay(arrow) }}
                    </button>
                  } @else {
                    <span class="arrow arrow--empty">·</span>
                  }
                }
              </div>
              <span class="end-row__total">{{ endTotals()[endIdx] || 0 }}</span>
              <button
                mat-icon-button
                type="button"
                aria-label="Sort end descending"
                [disabled]="!isLive() || !currentRoundEnds()[endIdx]?.length"
                (click)="autoSortEnd(endIdx)"
                matTooltip="Sort high → low"
              >
                <mat-icon>swap_vert</mat-icon>
              </button>
            </div>
          }
        </section>
      }

      @if (isLive()) {
        <section class="pad" [class.is-editing]="!!editTarget()">
          @if (editTarget()) {
            <div class="pad__edit-banner">
              <mat-icon>edit</mat-icon>
              Tap a value to replace ·
              <button mat-button (click)="cancelEdit()">Cancel</button>
            </div>
          }
          <div class="pad__grid">
            @for (v of padValues; track v) {
              <button type="button" [class]="arrowClass(v) + ' pad__btn'" (click)="recordArrow(v)">
                {{ arrowDisplay(v) }}
              </button>
            }
          </div>
          <div class="pad__actions">
            <button mat-stroked-button (click)="undoLast()">
              <mat-icon>undo</mat-icon>
              Undo
            </button>
            <button mat-stroked-button color="warn" (click)="resetCurrent()">
              <mat-icon>refresh</mat-icon>
              Reset archer
            </button>
            <span class="pad__hint">Keys: 1–9, 0 = 10, X, M, U / ⌫ = undo</span>
          </div>
        </section>
      } @else if (isPaused()) {
        <p class="brijjsports-empty">Session paused. Resume to continue scoring.</p>
      } @else if (isCompleted()) {
        <p class="brijjsports-empty">Session completed. Final scores are locked.</p>
      }
    } @else {
      <p class="brijjsports-empty">No archers attached to this session.</p>
    }
  </div>
}
